// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import reduceModulations from './reduceModulations'

const transformRadioForForm = r => {
  // prepare radio for form consumption
  const {
    architecture,
    atpcAlarmFlag,
    atpcFlag,
    atpcType,
    companyName,
    radioFavorite,
    radioId,
  } = r

  const {
    bandwidth,
    engineeringReference,
    maxPower,
    modelNumber,
    modulations,
  } = reduceModulations(r.modulations)

  const coordinatedPower = maxPower

  const powerType = castToString(r.powerType)

  const radioFamilyName = castToString(r.radioFamilyName) || 'N/A'

  // if null, cast to false
  const dynamicPowerFlag = !!r.dynamicPowerFlag

  // gets the first letter of this string value. Will be 'f' - Fixed, or 'a' - Adaptive
  const modulationType = r.modulationType.modulationType[0].toLowerCase()

  // For display purposes, if it's a favorite,
  // we want to display the favorite radio code and not the base radio code.
  const radioCode = (
    radioFavorite
      ? radioFavorite.favoriteRadioCode
      : r.radioCode
  )

  const legacyRadioCode = radioFavorite?.legacyRadioCode || null
  const radioFavoriteId = radioFavorite?.radioFavoriteId || null

  return {
    acmCoordinationAdvantageFlag: false,
    atpc: null,
    atpcAlarmFlag,
    atpcEnabled: false,
    atpcType,
    architecture,
    atpcFlag, // NOTE - does not currently prevent radios from getting ATPC set on them. - this is an API issue
    bandwidth,
    companyName,
    coordinatedPower,
    dynamicPowerFlag,
    engineeringReference,
    legacyRadioCode,
    maxPower,
    modelNumber,
    modulations,
    modulationType,
    powerType,
    radioCode,
    radioFamilyName,
    radioFavoriteId,
    radioId,
  }
}

export default transformRadioForForm
